@if (rangeVisible) {
    <span class="slider-range" [ngStyle]="rangeStyles"></span>
}

<span
    #handle
    class="slider-handle"
    [ngStyle]="minHandleStyles"
    [ngClass]="{ 'slider-handle-active': currentHandle === handleType.MinHandle, 'slider-active': active }"
    [attr.tabindex]="tabindex"
    (keydown)="onHandleKeydown($event, handleType.MinHandle)"
    (mousedown)="onMouseDown($event, handleType.MinHandle)"
    (touchstart)="onTouchStart($event, handleType.MinHandle)"
    (touchmove)="onTouchMove($event)"
    (touchend)="onTouchEnd()">
    @if (minIconTemplate) {
        <ng-container [ngTemplateOutlet]="minIconTemplate" />
    }
</span>

@if (range) {
    <span
        class="slider-handle"
        [ngStyle]="maxHandleStyles"
        [ngClass]="{ 'slider-handle-active': currentHandle === handleType.MaxHandle }"
        [attr.tabindex]="tabindex"
        (keydown)="onHandleKeydown($event, handleType.MaxHandle)"
        (mousedown)="onMouseDown($event, handleType.MaxHandle)"
        (touchstart)="onTouchStart($event, handleType.MaxHandle)"
        (touchmove)="onTouchMove($event)"
        (touchend)="onTouchEnd()">
        @if (maxIconTemplate) {
            <ng-container [ngTemplateOutlet]="maxIconTemplate" />
        }
    </span>
}

@if (!!stepId) {
    <div #pointSelector id="step-values">
        @for (step of steps; track $index; let i = $index) {
            <span [id]="stepId + step">
                <span> {{ i % stepDivider === 0 ? step : '•' }}</span>
            </span>
        }
    </div>
}
